/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ZerodhaReturnRouteImport } from "./routes/zerodha-return"
import { Route as ShareTargetRouteImport } from "./routes/share-target"
import { Route as MoreRouteImport } from "./routes/more"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as JoinRouteImport } from "./routes/join"
import { Route as DashboardRouteImport } from "./routes/dashboard"
import { Route as AddRouteImport } from "./routes/add"
import { Route as SplatRouteImport } from "./routes/$"
import { Route as SettingsRouteRouteImport } from "./routes/settings/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as UpcomingIndexRouteImport } from "./routes/upcoming/index"
import { Route as TransactionsIndexRouteImport } from "./routes/transactions/index"
import { Route as TaxIndexRouteImport } from "./routes/tax/index"
import { Route as SubscriptionsIndexRouteImport } from "./routes/subscriptions/index"
import { Route as SettingsIndexRouteImport } from "./routes/settings/index"
import { Route as ReportsIndexRouteImport } from "./routes/reports/index"
import { Route as NetWorthIndexRouteImport } from "./routes/net-worth/index"
import { Route as InvestmentsIndexRouteImport } from "./routes/investments/index"
import { Route as InsuranceIndexRouteImport } from "./routes/insurance/index"
import { Route as HeatmapIndexRouteImport } from "./routes/heatmap/index"
import { Route as GoalsIndexRouteImport } from "./routes/goals/index"
import { Route as DebtIndexRouteImport } from "./routes/debt/index"
import { Route as CalculatorsIndexRouteImport } from "./routes/calculators/index"
import { Route as BudgetsIndexRouteImport } from "./routes/budgets/index"
import { Route as AnalyticsIndexRouteImport } from "./routes/analytics/index"
import { Route as TransactionsReviewRouteImport } from "./routes/transactions/review"
import { Route as TransactionsDuplicatesRouteImport } from "./routes/transactions/duplicates"
import { Route as SettingsTokensRouteImport } from "./routes/settings/tokens"
import { Route as SettingsProfileRouteImport } from "./routes/settings/profile"
import { Route as SettingsPrivacyRouteImport } from "./routes/settings/privacy"
import { Route as SettingsPersonsRouteImport } from "./routes/settings/persons"
import { Route as SettingsNotificationsRouteImport } from "./routes/settings/notifications"
import { Route as SettingsMerchantsRouteImport } from "./routes/settings/merchants"
import { Route as SettingsIntegrationsRouteImport } from "./routes/settings/integrations"
import { Route as SettingsHouseholdRouteImport } from "./routes/settings/household"
import { Route as SettingsCategoriesRouteImport } from "./routes/settings/categories"
import { Route as SettingsBudgetsRouteImport } from "./routes/settings/budgets"
import { Route as SettingsAppearanceRouteImport } from "./routes/settings/appearance"
import { Route as SettingsAlertsRouteImport } from "./routes/settings/alerts"
import { Route as SettingsAccountsRouteImport } from "./routes/settings/accounts"
import { Route as CalculatorsXirrRouteImport } from "./routes/calculators/xirr"
import { Route as CalculatorsTaxRegimeRouteImport } from "./routes/calculators/tax-regime"
import { Route as CalculatorsSipRouteImport } from "./routes/calculators/sip"
import { Route as CalculatorsRentVsBuyRouteImport } from "./routes/calculators/rent-vs-buy"
import { Route as CalculatorsFireRouteImport } from "./routes/calculators/fire"
import { Route as CalculatorsEmiRouteImport } from "./routes/calculators/emi"
import { Route as AnalyticsMerchantsIdRouteImport } from "./routes/analytics/merchants.$id"
import { Route as AnalyticsCategoriesSlugRouteImport } from "./routes/analytics/categories.$slug"

const ZerodhaReturnRoute = ZerodhaReturnRouteImport.update({
  id: "/zerodha-return",
  path: "/zerodha-return",
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTargetRoute = ShareTargetRouteImport.update({
  id: "/share-target",
  path: "/share-target",
  getParentRoute: () => rootRouteImport,
} as any)
const MoreRoute = MoreRouteImport.update({
  id: "/more",
  path: "/more",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: "/join",
  path: "/join",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const AddRoute = AddRouteImport.update({
  id: "/add",
  path: "/add",
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const UpcomingIndexRoute = UpcomingIndexRouteImport.update({
  id: "/upcoming/",
  path: "/upcoming/",
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: "/transactions/",
  path: "/transactions/",
  getParentRoute: () => rootRouteImport,
} as any)
const TaxIndexRoute = TaxIndexRouteImport.update({
  id: "/tax/",
  path: "/tax/",
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsIndexRoute = SubscriptionsIndexRouteImport.update({
  id: "/subscriptions/",
  path: "/subscriptions/",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: "/reports/",
  path: "/reports/",
  getParentRoute: () => rootRouteImport,
} as any)
const NetWorthIndexRoute = NetWorthIndexRouteImport.update({
  id: "/net-worth/",
  path: "/net-worth/",
  getParentRoute: () => rootRouteImport,
} as any)
const InvestmentsIndexRoute = InvestmentsIndexRouteImport.update({
  id: "/investments/",
  path: "/investments/",
  getParentRoute: () => rootRouteImport,
} as any)
const InsuranceIndexRoute = InsuranceIndexRouteImport.update({
  id: "/insurance/",
  path: "/insurance/",
  getParentRoute: () => rootRouteImport,
} as any)
const HeatmapIndexRoute = HeatmapIndexRouteImport.update({
  id: "/heatmap/",
  path: "/heatmap/",
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsIndexRoute = GoalsIndexRouteImport.update({
  id: "/goals/",
  path: "/goals/",
  getParentRoute: () => rootRouteImport,
} as any)
const DebtIndexRoute = DebtIndexRouteImport.update({
  id: "/debt/",
  path: "/debt/",
  getParentRoute: () => rootRouteImport,
} as any)
const CalculatorsIndexRoute = CalculatorsIndexRouteImport.update({
  id: "/calculators/",
  path: "/calculators/",
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsIndexRoute = BudgetsIndexRouteImport.update({
  id: "/budgets/",
  path: "/budgets/",
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: "/analytics/",
  path: "/analytics/",
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsReviewRoute = TransactionsReviewRouteImport.update({
  id: "/transactions/review",
  path: "/transactions/review",
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsDuplicatesRoute = TransactionsDuplicatesRouteImport.update({
  id: "/transactions/duplicates",
  path: "/transactions/duplicates",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTokensRoute = SettingsTokensRouteImport.update({
  id: "/tokens",
  path: "/tokens",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsPrivacyRoute = SettingsPrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsPersonsRoute = SettingsPersonsRouteImport.update({
  id: "/persons",
  path: "/persons",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: "/notifications",
  path: "/notifications",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMerchantsRoute = SettingsMerchantsRouteImport.update({
  id: "/merchants",
  path: "/merchants",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: "/integrations",
  path: "/integrations",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsHouseholdRoute = SettingsHouseholdRouteImport.update({
  id: "/household",
  path: "/household",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsCategoriesRoute = SettingsCategoriesRouteImport.update({
  id: "/categories",
  path: "/categories",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsBudgetsRoute = SettingsBudgetsRouteImport.update({
  id: "/budgets",
  path: "/budgets",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: "/appearance",
  path: "/appearance",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAlertsRoute = SettingsAlertsRouteImport.update({
  id: "/alerts",
  path: "/alerts",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAccountsRoute = SettingsAccountsRouteImport.update({
  id: "/accounts",
  path: "/accounts",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const CalculatorsXirrRoute = CalculatorsXirrRouteImport.update({
  id: "/calculators/xirr",
  path: "/calculators/xirr",
  getParentRoute: () => rootRouteImport,
} as any)
const CalculatorsTaxRegimeRoute = CalculatorsTaxRegimeRouteImport.update({
  id: "/calculators/tax-regime",
  path: "/calculators/tax-regime",
  getParentRoute: () => rootRouteImport,
} as any)
const CalculatorsSipRoute = CalculatorsSipRouteImport.update({
  id: "/calculators/sip",
  path: "/calculators/sip",
  getParentRoute: () => rootRouteImport,
} as any)
const CalculatorsRentVsBuyRoute = CalculatorsRentVsBuyRouteImport.update({
  id: "/calculators/rent-vs-buy",
  path: "/calculators/rent-vs-buy",
  getParentRoute: () => rootRouteImport,
} as any)
const CalculatorsFireRoute = CalculatorsFireRouteImport.update({
  id: "/calculators/fire",
  path: "/calculators/fire",
  getParentRoute: () => rootRouteImport,
} as any)
const CalculatorsEmiRoute = CalculatorsEmiRouteImport.update({
  id: "/calculators/emi",
  path: "/calculators/emi",
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsMerchantsIdRoute = AnalyticsMerchantsIdRouteImport.update({
  id: "/analytics/merchants/$id",
  path: "/analytics/merchants/$id",
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsCategoriesSlugRoute = AnalyticsCategoriesSlugRouteImport.update({
  id: "/analytics/categories/$slug",
  path: "/analytics/categories/$slug",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/settings": typeof SettingsRouteRouteWithChildren
  "/$": typeof SplatRoute
  "/add": typeof AddRoute
  "/dashboard": typeof DashboardRoute
  "/join": typeof JoinRoute
  "/login": typeof LoginRoute
  "/more": typeof MoreRoute
  "/share-target": typeof ShareTargetRoute
  "/zerodha-return": typeof ZerodhaReturnRoute
  "/calculators/emi": typeof CalculatorsEmiRoute
  "/calculators/fire": typeof CalculatorsFireRoute
  "/calculators/rent-vs-buy": typeof CalculatorsRentVsBuyRoute
  "/calculators/sip": typeof CalculatorsSipRoute
  "/calculators/tax-regime": typeof CalculatorsTaxRegimeRoute
  "/calculators/xirr": typeof CalculatorsXirrRoute
  "/settings/accounts": typeof SettingsAccountsRoute
  "/settings/alerts": typeof SettingsAlertsRoute
  "/settings/appearance": typeof SettingsAppearanceRoute
  "/settings/budgets": typeof SettingsBudgetsRoute
  "/settings/categories": typeof SettingsCategoriesRoute
  "/settings/household": typeof SettingsHouseholdRoute
  "/settings/integrations": typeof SettingsIntegrationsRoute
  "/settings/merchants": typeof SettingsMerchantsRoute
  "/settings/notifications": typeof SettingsNotificationsRoute
  "/settings/persons": typeof SettingsPersonsRoute
  "/settings/privacy": typeof SettingsPrivacyRoute
  "/settings/profile": typeof SettingsProfileRoute
  "/settings/tokens": typeof SettingsTokensRoute
  "/transactions/duplicates": typeof TransactionsDuplicatesRoute
  "/transactions/review": typeof TransactionsReviewRoute
  "/analytics/": typeof AnalyticsIndexRoute
  "/budgets/": typeof BudgetsIndexRoute
  "/calculators/": typeof CalculatorsIndexRoute
  "/debt/": typeof DebtIndexRoute
  "/goals/": typeof GoalsIndexRoute
  "/heatmap/": typeof HeatmapIndexRoute
  "/insurance/": typeof InsuranceIndexRoute
  "/investments/": typeof InvestmentsIndexRoute
  "/net-worth/": typeof NetWorthIndexRoute
  "/reports/": typeof ReportsIndexRoute
  "/settings/": typeof SettingsIndexRoute
  "/subscriptions/": typeof SubscriptionsIndexRoute
  "/tax/": typeof TaxIndexRoute
  "/transactions/": typeof TransactionsIndexRoute
  "/upcoming/": typeof UpcomingIndexRoute
  "/analytics/categories/$slug": typeof AnalyticsCategoriesSlugRoute
  "/analytics/merchants/$id": typeof AnalyticsMerchantsIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/$": typeof SplatRoute
  "/add": typeof AddRoute
  "/dashboard": typeof DashboardRoute
  "/join": typeof JoinRoute
  "/login": typeof LoginRoute
  "/more": typeof MoreRoute
  "/share-target": typeof ShareTargetRoute
  "/zerodha-return": typeof ZerodhaReturnRoute
  "/calculators/emi": typeof CalculatorsEmiRoute
  "/calculators/fire": typeof CalculatorsFireRoute
  "/calculators/rent-vs-buy": typeof CalculatorsRentVsBuyRoute
  "/calculators/sip": typeof CalculatorsSipRoute
  "/calculators/tax-regime": typeof CalculatorsTaxRegimeRoute
  "/calculators/xirr": typeof CalculatorsXirrRoute
  "/settings/accounts": typeof SettingsAccountsRoute
  "/settings/alerts": typeof SettingsAlertsRoute
  "/settings/appearance": typeof SettingsAppearanceRoute
  "/settings/budgets": typeof SettingsBudgetsRoute
  "/settings/categories": typeof SettingsCategoriesRoute
  "/settings/household": typeof SettingsHouseholdRoute
  "/settings/integrations": typeof SettingsIntegrationsRoute
  "/settings/merchants": typeof SettingsMerchantsRoute
  "/settings/notifications": typeof SettingsNotificationsRoute
  "/settings/persons": typeof SettingsPersonsRoute
  "/settings/privacy": typeof SettingsPrivacyRoute
  "/settings/profile": typeof SettingsProfileRoute
  "/settings/tokens": typeof SettingsTokensRoute
  "/transactions/duplicates": typeof TransactionsDuplicatesRoute
  "/transactions/review": typeof TransactionsReviewRoute
  "/analytics": typeof AnalyticsIndexRoute
  "/budgets": typeof BudgetsIndexRoute
  "/calculators": typeof CalculatorsIndexRoute
  "/debt": typeof DebtIndexRoute
  "/goals": typeof GoalsIndexRoute
  "/heatmap": typeof HeatmapIndexRoute
  "/insurance": typeof InsuranceIndexRoute
  "/investments": typeof InvestmentsIndexRoute
  "/net-worth": typeof NetWorthIndexRoute
  "/reports": typeof ReportsIndexRoute
  "/settings": typeof SettingsIndexRoute
  "/subscriptions": typeof SubscriptionsIndexRoute
  "/tax": typeof TaxIndexRoute
  "/transactions": typeof TransactionsIndexRoute
  "/upcoming": typeof UpcomingIndexRoute
  "/analytics/categories/$slug": typeof AnalyticsCategoriesSlugRoute
  "/analytics/merchants/$id": typeof AnalyticsMerchantsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/settings": typeof SettingsRouteRouteWithChildren
  "/$": typeof SplatRoute
  "/add": typeof AddRoute
  "/dashboard": typeof DashboardRoute
  "/join": typeof JoinRoute
  "/login": typeof LoginRoute
  "/more": typeof MoreRoute
  "/share-target": typeof ShareTargetRoute
  "/zerodha-return": typeof ZerodhaReturnRoute
  "/calculators/emi": typeof CalculatorsEmiRoute
  "/calculators/fire": typeof CalculatorsFireRoute
  "/calculators/rent-vs-buy": typeof CalculatorsRentVsBuyRoute
  "/calculators/sip": typeof CalculatorsSipRoute
  "/calculators/tax-regime": typeof CalculatorsTaxRegimeRoute
  "/calculators/xirr": typeof CalculatorsXirrRoute
  "/settings/accounts": typeof SettingsAccountsRoute
  "/settings/alerts": typeof SettingsAlertsRoute
  "/settings/appearance": typeof SettingsAppearanceRoute
  "/settings/budgets": typeof SettingsBudgetsRoute
  "/settings/categories": typeof SettingsCategoriesRoute
  "/settings/household": typeof SettingsHouseholdRoute
  "/settings/integrations": typeof SettingsIntegrationsRoute
  "/settings/merchants": typeof SettingsMerchantsRoute
  "/settings/notifications": typeof SettingsNotificationsRoute
  "/settings/persons": typeof SettingsPersonsRoute
  "/settings/privacy": typeof SettingsPrivacyRoute
  "/settings/profile": typeof SettingsProfileRoute
  "/settings/tokens": typeof SettingsTokensRoute
  "/transactions/duplicates": typeof TransactionsDuplicatesRoute
  "/transactions/review": typeof TransactionsReviewRoute
  "/analytics/": typeof AnalyticsIndexRoute
  "/budgets/": typeof BudgetsIndexRoute
  "/calculators/": typeof CalculatorsIndexRoute
  "/debt/": typeof DebtIndexRoute
  "/goals/": typeof GoalsIndexRoute
  "/heatmap/": typeof HeatmapIndexRoute
  "/insurance/": typeof InsuranceIndexRoute
  "/investments/": typeof InvestmentsIndexRoute
  "/net-worth/": typeof NetWorthIndexRoute
  "/reports/": typeof ReportsIndexRoute
  "/settings/": typeof SettingsIndexRoute
  "/subscriptions/": typeof SubscriptionsIndexRoute
  "/tax/": typeof TaxIndexRoute
  "/transactions/": typeof TransactionsIndexRoute
  "/upcoming/": typeof UpcomingIndexRoute
  "/analytics/categories/$slug": typeof AnalyticsCategoriesSlugRoute
  "/analytics/merchants/$id": typeof AnalyticsMerchantsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/settings"
    | "/$"
    | "/add"
    | "/dashboard"
    | "/join"
    | "/login"
    | "/more"
    | "/share-target"
    | "/zerodha-return"
    | "/calculators/emi"
    | "/calculators/fire"
    | "/calculators/rent-vs-buy"
    | "/calculators/sip"
    | "/calculators/tax-regime"
    | "/calculators/xirr"
    | "/settings/accounts"
    | "/settings/alerts"
    | "/settings/appearance"
    | "/settings/budgets"
    | "/settings/categories"
    | "/settings/household"
    | "/settings/integrations"
    | "/settings/merchants"
    | "/settings/notifications"
    | "/settings/persons"
    | "/settings/privacy"
    | "/settings/profile"
    | "/settings/tokens"
    | "/transactions/duplicates"
    | "/transactions/review"
    | "/analytics/"
    | "/budgets/"
    | "/calculators/"
    | "/debt/"
    | "/goals/"
    | "/heatmap/"
    | "/insurance/"
    | "/investments/"
    | "/net-worth/"
    | "/reports/"
    | "/settings/"
    | "/subscriptions/"
    | "/tax/"
    | "/transactions/"
    | "/upcoming/"
    | "/analytics/categories/$slug"
    | "/analytics/merchants/$id"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/$"
    | "/add"
    | "/dashboard"
    | "/join"
    | "/login"
    | "/more"
    | "/share-target"
    | "/zerodha-return"
    | "/calculators/emi"
    | "/calculators/fire"
    | "/calculators/rent-vs-buy"
    | "/calculators/sip"
    | "/calculators/tax-regime"
    | "/calculators/xirr"
    | "/settings/accounts"
    | "/settings/alerts"
    | "/settings/appearance"
    | "/settings/budgets"
    | "/settings/categories"
    | "/settings/household"
    | "/settings/integrations"
    | "/settings/merchants"
    | "/settings/notifications"
    | "/settings/persons"
    | "/settings/privacy"
    | "/settings/profile"
    | "/settings/tokens"
    | "/transactions/duplicates"
    | "/transactions/review"
    | "/analytics"
    | "/budgets"
    | "/calculators"
    | "/debt"
    | "/goals"
    | "/heatmap"
    | "/insurance"
    | "/investments"
    | "/net-worth"
    | "/reports"
    | "/settings"
    | "/subscriptions"
    | "/tax"
    | "/transactions"
    | "/upcoming"
    | "/analytics/categories/$slug"
    | "/analytics/merchants/$id"
  id:
    | "__root__"
    | "/"
    | "/settings"
    | "/$"
    | "/add"
    | "/dashboard"
    | "/join"
    | "/login"
    | "/more"
    | "/share-target"
    | "/zerodha-return"
    | "/calculators/emi"
    | "/calculators/fire"
    | "/calculators/rent-vs-buy"
    | "/calculators/sip"
    | "/calculators/tax-regime"
    | "/calculators/xirr"
    | "/settings/accounts"
    | "/settings/alerts"
    | "/settings/appearance"
    | "/settings/budgets"
    | "/settings/categories"
    | "/settings/household"
    | "/settings/integrations"
    | "/settings/merchants"
    | "/settings/notifications"
    | "/settings/persons"
    | "/settings/privacy"
    | "/settings/profile"
    | "/settings/tokens"
    | "/transactions/duplicates"
    | "/transactions/review"
    | "/analytics/"
    | "/budgets/"
    | "/calculators/"
    | "/debt/"
    | "/goals/"
    | "/heatmap/"
    | "/insurance/"
    | "/investments/"
    | "/net-worth/"
    | "/reports/"
    | "/settings/"
    | "/subscriptions/"
    | "/tax/"
    | "/transactions/"
    | "/upcoming/"
    | "/analytics/categories/$slug"
    | "/analytics/merchants/$id"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  AddRoute: typeof AddRoute
  DashboardRoute: typeof DashboardRoute
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  MoreRoute: typeof MoreRoute
  ShareTargetRoute: typeof ShareTargetRoute
  ZerodhaReturnRoute: typeof ZerodhaReturnRoute
  CalculatorsEmiRoute: typeof CalculatorsEmiRoute
  CalculatorsFireRoute: typeof CalculatorsFireRoute
  CalculatorsRentVsBuyRoute: typeof CalculatorsRentVsBuyRoute
  CalculatorsSipRoute: typeof CalculatorsSipRoute
  CalculatorsTaxRegimeRoute: typeof CalculatorsTaxRegimeRoute
  CalculatorsXirrRoute: typeof CalculatorsXirrRoute
  TransactionsDuplicatesRoute: typeof TransactionsDuplicatesRoute
  TransactionsReviewRoute: typeof TransactionsReviewRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  BudgetsIndexRoute: typeof BudgetsIndexRoute
  CalculatorsIndexRoute: typeof CalculatorsIndexRoute
  DebtIndexRoute: typeof DebtIndexRoute
  GoalsIndexRoute: typeof GoalsIndexRoute
  HeatmapIndexRoute: typeof HeatmapIndexRoute
  InsuranceIndexRoute: typeof InsuranceIndexRoute
  InvestmentsIndexRoute: typeof InvestmentsIndexRoute
  NetWorthIndexRoute: typeof NetWorthIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  SubscriptionsIndexRoute: typeof SubscriptionsIndexRoute
  TaxIndexRoute: typeof TaxIndexRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
  UpcomingIndexRoute: typeof UpcomingIndexRoute
  AnalyticsCategoriesSlugRoute: typeof AnalyticsCategoriesSlugRoute
  AnalyticsMerchantsIdRoute: typeof AnalyticsMerchantsIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/zerodha-return": {
      id: "/zerodha-return"
      path: "/zerodha-return"
      fullPath: "/zerodha-return"
      preLoaderRoute: typeof ZerodhaReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/share-target": {
      id: "/share-target"
      path: "/share-target"
      fullPath: "/share-target"
      preLoaderRoute: typeof ShareTargetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/more": {
      id: "/more"
      path: "/more"
      fullPath: "/more"
      preLoaderRoute: typeof MoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/join": {
      id: "/join"
      path: "/join"
      fullPath: "/join"
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/add": {
      id: "/add"
      path: "/add"
      fullPath: "/add"
      preLoaderRoute: typeof AddRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/$": {
      id: "/$"
      path: "/$"
      fullPath: "/$"
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings": {
      id: "/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/upcoming/": {
      id: "/upcoming/"
      path: "/upcoming"
      fullPath: "/upcoming/"
      preLoaderRoute: typeof UpcomingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/transactions/": {
      id: "/transactions/"
      path: "/transactions"
      fullPath: "/transactions/"
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/tax/": {
      id: "/tax/"
      path: "/tax"
      fullPath: "/tax/"
      preLoaderRoute: typeof TaxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/subscriptions/": {
      id: "/subscriptions/"
      path: "/subscriptions"
      fullPath: "/subscriptions/"
      preLoaderRoute: typeof SubscriptionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/": {
      id: "/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/reports/": {
      id: "/reports/"
      path: "/reports"
      fullPath: "/reports/"
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/net-worth/": {
      id: "/net-worth/"
      path: "/net-worth"
      fullPath: "/net-worth/"
      preLoaderRoute: typeof NetWorthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/investments/": {
      id: "/investments/"
      path: "/investments"
      fullPath: "/investments/"
      preLoaderRoute: typeof InvestmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/insurance/": {
      id: "/insurance/"
      path: "/insurance"
      fullPath: "/insurance/"
      preLoaderRoute: typeof InsuranceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/heatmap/": {
      id: "/heatmap/"
      path: "/heatmap"
      fullPath: "/heatmap/"
      preLoaderRoute: typeof HeatmapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/goals/": {
      id: "/goals/"
      path: "/goals"
      fullPath: "/goals/"
      preLoaderRoute: typeof GoalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/debt/": {
      id: "/debt/"
      path: "/debt"
      fullPath: "/debt/"
      preLoaderRoute: typeof DebtIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/calculators/": {
      id: "/calculators/"
      path: "/calculators"
      fullPath: "/calculators/"
      preLoaderRoute: typeof CalculatorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/budgets/": {
      id: "/budgets/"
      path: "/budgets"
      fullPath: "/budgets/"
      preLoaderRoute: typeof BudgetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/analytics/": {
      id: "/analytics/"
      path: "/analytics"
      fullPath: "/analytics/"
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/transactions/review": {
      id: "/transactions/review"
      path: "/transactions/review"
      fullPath: "/transactions/review"
      preLoaderRoute: typeof TransactionsReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/transactions/duplicates": {
      id: "/transactions/duplicates"
      path: "/transactions/duplicates"
      fullPath: "/transactions/duplicates"
      preLoaderRoute: typeof TransactionsDuplicatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/tokens": {
      id: "/settings/tokens"
      path: "/tokens"
      fullPath: "/settings/tokens"
      preLoaderRoute: typeof SettingsTokensRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/profile": {
      id: "/settings/profile"
      path: "/profile"
      fullPath: "/settings/profile"
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/privacy": {
      id: "/settings/privacy"
      path: "/privacy"
      fullPath: "/settings/privacy"
      preLoaderRoute: typeof SettingsPrivacyRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/persons": {
      id: "/settings/persons"
      path: "/persons"
      fullPath: "/settings/persons"
      preLoaderRoute: typeof SettingsPersonsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/notifications": {
      id: "/settings/notifications"
      path: "/notifications"
      fullPath: "/settings/notifications"
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/merchants": {
      id: "/settings/merchants"
      path: "/merchants"
      fullPath: "/settings/merchants"
      preLoaderRoute: typeof SettingsMerchantsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/integrations": {
      id: "/settings/integrations"
      path: "/integrations"
      fullPath: "/settings/integrations"
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/household": {
      id: "/settings/household"
      path: "/household"
      fullPath: "/settings/household"
      preLoaderRoute: typeof SettingsHouseholdRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/categories": {
      id: "/settings/categories"
      path: "/categories"
      fullPath: "/settings/categories"
      preLoaderRoute: typeof SettingsCategoriesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/budgets": {
      id: "/settings/budgets"
      path: "/budgets"
      fullPath: "/settings/budgets"
      preLoaderRoute: typeof SettingsBudgetsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/appearance": {
      id: "/settings/appearance"
      path: "/appearance"
      fullPath: "/settings/appearance"
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/alerts": {
      id: "/settings/alerts"
      path: "/alerts"
      fullPath: "/settings/alerts"
      preLoaderRoute: typeof SettingsAlertsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/accounts": {
      id: "/settings/accounts"
      path: "/accounts"
      fullPath: "/settings/accounts"
      preLoaderRoute: typeof SettingsAccountsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/calculators/xirr": {
      id: "/calculators/xirr"
      path: "/calculators/xirr"
      fullPath: "/calculators/xirr"
      preLoaderRoute: typeof CalculatorsXirrRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/calculators/tax-regime": {
      id: "/calculators/tax-regime"
      path: "/calculators/tax-regime"
      fullPath: "/calculators/tax-regime"
      preLoaderRoute: typeof CalculatorsTaxRegimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/calculators/sip": {
      id: "/calculators/sip"
      path: "/calculators/sip"
      fullPath: "/calculators/sip"
      preLoaderRoute: typeof CalculatorsSipRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/calculators/rent-vs-buy": {
      id: "/calculators/rent-vs-buy"
      path: "/calculators/rent-vs-buy"
      fullPath: "/calculators/rent-vs-buy"
      preLoaderRoute: typeof CalculatorsRentVsBuyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/calculators/fire": {
      id: "/calculators/fire"
      path: "/calculators/fire"
      fullPath: "/calculators/fire"
      preLoaderRoute: typeof CalculatorsFireRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/calculators/emi": {
      id: "/calculators/emi"
      path: "/calculators/emi"
      fullPath: "/calculators/emi"
      preLoaderRoute: typeof CalculatorsEmiRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/analytics/merchants/$id": {
      id: "/analytics/merchants/$id"
      path: "/analytics/merchants/$id"
      fullPath: "/analytics/merchants/$id"
      preLoaderRoute: typeof AnalyticsMerchantsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/analytics/categories/$slug": {
      id: "/analytics/categories/$slug"
      path: "/analytics/categories/$slug"
      fullPath: "/analytics/categories/$slug"
      preLoaderRoute: typeof AnalyticsCategoriesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteRouteChildren {
  SettingsAccountsRoute: typeof SettingsAccountsRoute
  SettingsAlertsRoute: typeof SettingsAlertsRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsBudgetsRoute: typeof SettingsBudgetsRoute
  SettingsCategoriesRoute: typeof SettingsCategoriesRoute
  SettingsHouseholdRoute: typeof SettingsHouseholdRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsMerchantsRoute: typeof SettingsMerchantsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsPersonsRoute: typeof SettingsPersonsRoute
  SettingsPrivacyRoute: typeof SettingsPrivacyRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsTokensRoute: typeof SettingsTokensRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAccountsRoute: SettingsAccountsRoute,
  SettingsAlertsRoute: SettingsAlertsRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsBudgetsRoute: SettingsBudgetsRoute,
  SettingsCategoriesRoute: SettingsCategoriesRoute,
  SettingsHouseholdRoute: SettingsHouseholdRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsMerchantsRoute: SettingsMerchantsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsPersonsRoute: SettingsPersonsRoute,
  SettingsPrivacyRoute: SettingsPrivacyRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsTokensRoute: SettingsTokensRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  AddRoute: AddRoute,
  DashboardRoute: DashboardRoute,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  MoreRoute: MoreRoute,
  ShareTargetRoute: ShareTargetRoute,
  ZerodhaReturnRoute: ZerodhaReturnRoute,
  CalculatorsEmiRoute: CalculatorsEmiRoute,
  CalculatorsFireRoute: CalculatorsFireRoute,
  CalculatorsRentVsBuyRoute: CalculatorsRentVsBuyRoute,
  CalculatorsSipRoute: CalculatorsSipRoute,
  CalculatorsTaxRegimeRoute: CalculatorsTaxRegimeRoute,
  CalculatorsXirrRoute: CalculatorsXirrRoute,
  TransactionsDuplicatesRoute: TransactionsDuplicatesRoute,
  TransactionsReviewRoute: TransactionsReviewRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  BudgetsIndexRoute: BudgetsIndexRoute,
  CalculatorsIndexRoute: CalculatorsIndexRoute,
  DebtIndexRoute: DebtIndexRoute,
  GoalsIndexRoute: GoalsIndexRoute,
  HeatmapIndexRoute: HeatmapIndexRoute,
  InsuranceIndexRoute: InsuranceIndexRoute,
  InvestmentsIndexRoute: InvestmentsIndexRoute,
  NetWorthIndexRoute: NetWorthIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  SubscriptionsIndexRoute: SubscriptionsIndexRoute,
  TaxIndexRoute: TaxIndexRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
  UpcomingIndexRoute: UpcomingIndexRoute,
  AnalyticsCategoriesSlugRoute: AnalyticsCategoriesSlugRoute,
  AnalyticsMerchantsIdRoute: AnalyticsMerchantsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
